import { BASE_URL } from 'config/urls';

import { get, requestSdk } from 'utils/sdk';

export const fetchCustomer = async () =>
  await requestSdk(() => get(`${BASE_URL}/v1/subscriptions/customer/`));

export const fetchSubscriptionTemplates = async () =>
  await requestSdk(() => get(`${BASE_URL}/v1/subscriptions/templates/`));
